<template>
    <div>
        <a :href="link"
            :title="linkTitle">
            <div class="relative w-full h-full overflow-hidden"
                :style="'background:' + media.color">

                <div v-if="'breaking' === flag" 
                    class="absolute top-0 right-0 bg-mh-red-100 text-white text-sm font-medium font-roboto py-2 px-3 z-10">BREAKING NEWS</div>

                <div v-if="'latest' === flag" 
                    class="absolute top-0 right-0 bg-mh-green-100 text-white text-sm font-medium font-roboto py-2 px-3 z-10">LATEST NEWS</div>

                <div v-if="'developing' === flag" 
                    class="absolute top-0 right-0 bg-mh-green-100 text-white text-sm font-medium font-roboto py-2 px-3 z-10">DEVELOPING STORY</div>

                <svg class="absolute top-0 left-0" width="100%" height="110%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x-ref="featuredPlaceholder">
                    <rect :fill="media.color" width="100%" height="100%"/>
                    <svg x="50%" y="50%" width="40px" height="34px" overflow="visible">
                        <image x="-20px" y="-17px" width="40px" height="34px" xlink:href="https://cdn.mihaaru.com/assets/mhr/images/logo-header.png"/>
                    </svg>
                </svg>

                <img src='data:image/svg+xml;utf8,<svg fill-opacity="0" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"></svg>'
                    :data-src="dataSrc"
                    :alt="linkTitle"
                    class="absolute top-0 left-0 object-cover w-full h-full lazyload" />
            </div>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imageLoaded: false,
            imageSize: {
                width: 'auto',
                height: 'auto'
            }
        }
    },
    props: {
        size: {
            type: String,
            default: 'thumb'
        },
        link: {
            type: String,
            default: null
        },
        media: {
            type: Object,
            default: null
        },
        shortHeadline: {
            type: String,
            default: null
        },
        gallery: {
            type: Boolean,
            default: false
        },
        resize: {
            type: Boolean,
            default: false
        },
        flag: {
            type: String,
            default: 'none'
        }
    },
    computed: {
        linkTitle() {
            // return this.shortHeadline
        },
        dataSrc() {
            if ('image' === this.media.type) {
                return this.$root.CDN_GET(this.media.image, this.size)

            } else if('photo' === this.media.type) {
                return this.$root.CDN_GET(this.media.photo.public_file, this.size)

            } else {
                return this.$root.CDN_YOUTUBE(this.media.image)
            }
                
        }
    },
    methods: {
        resizeImage() {
            // resize image
        }
    },
    beforeMount() {
        this.size = this.size.toLowerCase()
        if (true === this.resize) {
            this.resizeImage()
        }
    }
}
</script>